export const getUser = ( state) => {
    return state.user
}